export const sortByDate = (data, ascending = true) => {
  return data.sort((a, b) => {
    return ascending ? new Date(b.date) - new Date(a.date) : new Date(a.date) - new Date(b.date)
  })
}
export const sortByName = data => {
  return data.sort((a, b) => a.name.localeCompare(b.name))
}
